
export enum FolderTypeEnum {
    default,
    sharepoint,
    sharepointSite,
    oneDrive,
    teamChannel,
    teamMainSite,
    oneDriveSubFolder,
    sharepointList,
    sharepointHubSite,
    docubird
}
